import { useMemo, useState } from 'react';
import { datadogRum } from '@datadog/browser-rum';
import {
  filterAllContributors,
  filterAllTeamsGroupAndAllContributors
} from '../ContributorsAndTeams.service';
import { getAllTeamsGroup, getTreeSecondLevel } from 'common/utils/utils';
import isEmpty from 'lodash/isEmpty';

const DD_VITAL_METRIC_NAME = 'company_settings_teams_and_contributors_search';

const useTeamsFilters = ({ teams = [], treeTeams }) => {
  const [searchInput, setSearchInput] = useState('');

  const teamsInView = useMemo(() => {
    datadogRum.startDurationVital(DD_VITAL_METRIC_NAME);
    const allTeamsGroup = getAllTeamsGroup(treeTeams);
    const isAllTeamsGroup = !isEmpty(allTeamsGroup);

    const treeTeamsFiltered = isAllTeamsGroup
      ? getTreeSecondLevel(treeTeams)
      : filterAllContributors(treeTeams);

    if (!searchInput) {
      return treeTeamsFiltered;
    }
    const filteredData = teams.filter(({ name }) =>
      name.toLowerCase().includes(searchInput.toLowerCase())
    );
    // here we can append more filter logic in the future
    const result = filterAllTeamsGroupAndAllContributors(filteredData);
    datadogRum.stopDurationVital(DD_VITAL_METRIC_NAME);
    return result;
  }, [searchInput, teams]);

  return {
    searchInput,
    setSearchInput,
    teamsInView
  };
};

export default useTeamsFilters;
